import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManagementBaseUrl, userManagement } from "../endpoints";

export const voucherFinanceService = createApi({
  reducerPath: "voucherFinanceService",
  baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
  tagTypes: ["voucherFinance"],
  endpoints: (builder) => ({
    getAllVoucherFinance: builder.mutation({
      query: (body) => ({
        url: `${userManagement.voucherFinanceController.getAllVoucherFinance}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    searchVoucherFinance: builder.mutation({
      query: (body) => ({
        url: userManagement.voucherFinanceController.searchVoucherFinance,
        method: "POST",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    getVoucherFinanceById: builder.mutation({
      query: (body) => ({
        url: `${userManagement.voucherFinanceController.getVoucherFinanceById}/${body.id}`,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    saveVoucherFinance: builder.mutation({
      query: (body) => ({
        url: userManagement.voucherFinanceController.saveVoucherFinance,
        method: "POST",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    updateVoucherFinance: builder.mutation({
      query: (body) => ({
        url: `${userManagement.voucherFinanceController.updateVoucherFinance}/${body.id}`,
        method: "PUT",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    deleteVoucherFinance: builder.mutation({
      query: (body) => ({
        url: `${userManagement.voucherFinanceController.deleteVoucherFinance}/${body.id}`,
        method: "DELETE",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    findAllVoucherFinance: builder.mutation({
      query: (body) => ({
        url: userManagement.voucherFinanceController.findAllVoucherFinance,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    bulkUploadVoucherFinance: builder.mutation({
      query: (body) => ({
        url: userManagement.voucherFinanceController.bulkUploadVoucherFinance,
        method: "POST",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    findAllVoucherFinanaceApprovalStatus: builder.mutation({
      query: (body) => ({
        url: userManagement.voucherFinanceController.findAllVoucherFinanaceApprovalStatus,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),

    // 🔹 New API for fetching parties
    getAllParties: builder.mutation({
      query: (body) => ({
        url: userManagement.voucherFinanceController.getAllParties,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
  }),
});

export const {
  useGetAllVoucherFinanceMutation,
  useSearchVoucherFinanceMutation,
  useGetVoucherFinanceByIdMutation,
  useSaveVoucherFinanceMutation,
  useUpdateVoucherFinanceMutation,
  useDeleteVoucherFinanceMutation,
  useFindAllVoucherFinanceMutation,
  useBulkUploadVoucherFinanceMutation,
  useFindAllVoucherFinanaceApprovalStatusMutation,
  useGetAllPartiesMutation,
} = voucherFinanceService;
